import { cn } from "../lib/cn";

export interface SkeletonProps {
  variant?: "text" | "card" | "circle" | "stat";
  width?: string | number;
  height?: string | number;
  className?: string;
}

const variantDefaults = {
  text: { width: "100%", height: "16px", extra: "rounded-sm" },
  card: { width: "100%", height: "120px", extra: "rounded-sm" },
  circle: { width: "40px", height: "40px", extra: "rounded-full" },
  stat: { width: "200px", height: "64px", extra: "rounded-sm" },
} as const;

export function Skeleton({
  variant = "text",
  width,
  height,
  className,
}: SkeletonProps) {
  const defaults = variantDefaults[variant];

  return (
    <div
      className={cn("bg-gold-dim/30 animate-pulse", defaults.extra, className)}
      style={{
        width: width ?? defaults.width,
        height: height ?? defaults.height,
      }}
      aria-hidden="true"
    />
  );
}
